import React from "react";
import NavigationBar from "../common/NavigationBar";
import logo from "../../assets/img/i3web-logo.svg";

export default function Header({ children }) {
  return (
    <header className="bg-[#363C55]  px-4 h-[50px]  flex items-center w-full relative z-10 py-[1px]">
      <div className="flex items-center justify-between flex-1">
        <div className=" flex items-center gap-4 md:gap-0">
          <div className="md:w-[268px]">
            <img src={logo} alt="" />
          </div>{" "}
          {children}
        </div>
        <NavigationBar />
      </div>
    </header>
  );
}
